export default "__VITE_ASSET__CGvWW2ws__"